import { usePathPrefix } from './usePathPrefix'

const buildUrl = (element, path) =>
  element.parentPage && element.parentPage.length === 1
    ? buildUrl(element.parentPage[0], `/${element.slug}${path}`)
    : `/${element.slug}${path}`

const getLinkUrl = link => {
  if (link.element?.__typename === 'CraftContent_home_home_Entry') {
    return `/`
  }

  if (link.element?.__typename === 'CraftContent_article_default_Entry') {
    return `/lift-storys/${link.element.slug}`
  }

  if (link.element?.slug) {
    return buildUrl(link.element, '')
  }

  return link.url
}

export const useLink = link => {
  const pathPrefix = usePathPrefix(link)

  if (!link) {
    return { label: '', url: '' }
  }

  const linkUrl = getLinkUrl(link)
  const isExternal = ['http', 'https', 'mailto', 'tel'].some(protocol =>
    linkUrl?.startsWith(protocol),
  )

  return {
    label: link?.text,
    url: isExternal ? linkUrl : `${pathPrefix}${linkUrl}`,
  }
}
